import { useContext } from 'react';

import ComposerContext from 'components/composer/contexts/composer_context';

export default function useHasRemovableThread() {
  const { composition } = useContext(ComposerContext);
  return !!composition.content.quotedPlain;
}
